import { computed } from 'vue'
import { useLanguageStore } from '@/core/stores/language.store'

export function useDateFormatToShow(options = {}) {
  const { show = {} } = options
  const { hour = false, minutes = false, seconds = false } = show
  const languageStore = useLanguageStore()

  const format = computed(() => {
    let base
    switch (languageStore.currentLanguage) {
      case 'pt-br':
        base = 'DD/MM/YYYY'
        break
      case 'es-la':
        base = 'DD/MM/YYYY'
        break
      case 'en':
        base = 'MM/DD/YYYY'
        break
      case 'zh-cn':
      case 'ja':
        base = 'YYYY/MM/DD'
        break
      default:
        base = 'YYYY-MM-DD'
    }

    const timeParts = []
    if (hour)
      timeParts.push('HH')
    if (minutes)
      timeParts.push('mm')
    if (seconds)
      timeParts.push('ss')
    const timeFormat = timeParts.length ? ` ${timeParts.join(':')}` : ''

    return base + timeFormat
  })

  return format
}
